// Helpers for dealing with login / signup redirects.

import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { HgLocalStorageKey } from '@/models';

import { StorageNamespace } from '../storage-namespaces';

// Whenever you add a new redirect action, make sure to add its corresponding state type variation to the RedirectActionPayload union type.
// This way, TypeScript will enforce that the redirect state is correctly typed when setting or getting it.
export enum RedirectAction {
  SAVE_FAVORITE = 'save_favorite',
  SAVE_CUSTOM_POI_SRP = 'save_custom_poi_srp',
  SAVE_CUSTOM_POI_PDP = 'save_custom_poi_pdp',
  PROMOTE_ACCOUNT_CREATION_PDP = 'promote_account_creation_pdp',
  GOOGLE_ONE_TAP = 'google_one_tap',
}

export type RedirectActionPayload =
  | {
      redirectAction: RedirectAction.SAVE_FAVORITE;
      redirectPayload: { listingIdAwaitingLogin: string };
    }
  | {
      redirectAction: RedirectAction.SAVE_CUSTOM_POI_PDP;
      redirectPayload: { eventAction: 'auth_sign_up' | 'auth_login' };
    }
  | {
      redirectAction: RedirectAction.PROMOTE_ACCOUNT_CREATION_PDP;
      redirectPayload: { eventAction: 'auth_sign_up' };
    }
  | {
      redirectAction: RedirectAction.GOOGLE_ONE_TAP;
      redirectPayload?: undefined;
    }
  | {
      redirectAction?: undefined;
      redirectPayload?: undefined;
    };

export type RedirectState = { redirectUrl: string | undefined } & RedirectActionPayload;

let storageHelper: StorageHelper;

function getStorageHelper(): StorageHelper {
  if (!storageHelper) {
    storageHelper = new StorageHelper(StorageNamespace.seeker);
  }

  return storageHelper;
}

// Called before redirecting users to the login / signup page and back.
// Pages can store data before the redirect flow and retrieve it after to pick up the work where we left.
export function setRedirectState(redirectState: RedirectState): void {
  getStorageHelper().setLocalStorageItem(HgLocalStorageKey.REDIRECT_STATE, redirectState);
}

// Called after the login/signip flow is complete to retrieve the saved data and to pick up the work where we left.
export function getRedirectState(): RedirectState | null {
  return getStorageHelper().getLocalStorageItem(HgLocalStorageKey.REDIRECT_STATE);
}

export function removeRedirectState(): void {
  getStorageHelper().removeLocalStorageItem(HgLocalStorageKey.REDIRECT_STATE);
}
